import type { PlanStatus } from '@/types'
import type { CalcPath, WavePlanStatusValue } from '@/api/wavePlans'
import { getStatusLabel } from '@/utils/statusConfig'

/** Plan identity shown by the roll-up. */
export interface WavePlan {
  id: string
  name: string
  status: PlanStatus | WavePlanStatusValue
  calendarId: string
}

export function wavePlanPath(
  planId: string,
  view?: 'skus' | 'distribution-centers'
) {
  return `/wave-planning/plans/${planId}${view ? `/${view}` : ''}`
}

export function wavePlanStatusLabel(status: WavePlan['status']) {
  return status === 'NOT_STARTED' ? 'Not started' : getStatusLabel(status)
}

/** The wave plan's calculation path; the AP's plan type is always Core. */
export function calcPathLabel(calcPath: CalcPath) {
  return calcPath === 'CORE' ? 'Core / SBA' : 'Seasonal'
}

export function wavePlanMfpLabel(plan: { mfps: { name: string }[] }) {
  return plan.mfps.map(mfp => mfp.name).join(', ') || 'Not associated'
}

/** Mirrors the backend roll-up limit (MAX_ROLLUP_PLANS). */
export const MAX_ROLLUP_PLANS = 100

export function waveRollupPath(ids: string[]) {
  const params = new URLSearchParams({ planIds: [...new Set(ids)].join(',') })
  return `/wave-planning/rollup?${params}`
}

export function rollupIdsFromParams(params: URLSearchParams): string[] {
  return [
    ...new Set(
      params
        .getAll('planIds')
        .flatMap(value => value.split(','))
        .map(value => value.trim())
        .filter(Boolean)
    ),
  ]
}
